<script>
  export let name = '';
  export let size = 'md'; // xs, sm, md, lg, xl
  export let color = 'currentColor';
  export let rotation = 0; // degrees
</script>

{#if name}
  <span 
    class="icon icon-{size}" 
    style="color: {color}; transform: rotate({rotation}deg);"
    role="img"
    aria-label={name}
  >
    {#if name === 'loading'}
      <svg viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" opacity="0.25"/>
        <path fill="currentColor" d="M4 12a8 8 0 0 1 8-8V2.5a1.5 1.5 0 0 0-3 0V4a8 8 0 0 0 8 8h1.5a1.5 1.5 0 0 0 0-3H12a8 8 0 0 1-8-8z" opacity="0.75">
          <animateTransform attributeName="transform" type="rotate" dur="1s" values="0 12 12;360 12 12" repeatCount="indefinite"/>
        </path>
      </svg>
    {:else if name === 'error'}
      ❌
    {:else if name === 'warning'}
      ⚠️
    {:else if name === 'info'}
      ℹ️
    {:else if name === 'success'}
      ✅
    {:else if name === 'empty'}
      📭
    {:else if name === 'search'}
      🔍
    {:else if name === 'close'}
      ✕
    {:else if name === 'check'}
      ✓
    {:else if name === 'arrow-up'}
      ↑
    {:else if name === 'arrow-down'}
      ↓
    {:else if name === 'arrow-left'}
      ←
    {:else if name === 'arrow-right'}
      →
    {:else if name === 'chevron-left'}
      ‹
    {:else if name === 'chevron-right'}
      ›
    {:else if name === 'chevron-double-left'}
      «
    {:else if name === 'chevron-double-right'}
      »
    {:else}
      {name}
    {/if}
  </span>
{/if}

<style>
  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    flex-shrink: 0;
  }

  .icon svg {
    width: 100%;
    height: 100%;
  }

  /* Size variants */
  .icon-xs {
    width: 12px;
    height: 12px;
    font-size: 12px;
  }

  .icon-sm {
    width: 16px;
    height: 16px;
    font-size: 16px;
  }

  .icon-md {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }

  .icon-lg {
    width: 24px;
    height: 24px;
    font-size: 24px;
  }

  .icon-xl {
    width: 32px;
    height: 32px;
    font-size: 32px;
  }
</style> 